import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";
import { PROVIDER_COMPANIES } from "../Shared/CommonConstant";

const URL = process.env.React_App_BaseUrl;

const GetUser = (data) => {
  return axios
    .get(`${URL}/user`, {
      headers: { requesttype: data.requesttype, isAscending: data.isAscending },
      // SUPER_ADMIN only: another admin's users, or "ALL". Left out = own users.
      params: data.adminClientId ? { adminClientId: data.adminClientId } : undefined,
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const GetLogin = () => {
  return axios
    .get(`${URL}/getlogin`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const PostUser = (recData) => {
  return axios.post(`${URL}/user`, recData).then((response) => {
    const res = response.data;
    if (res.error) {
      ToastError(res.message);
    } else {
      ToastSuccess(res.message);
      return res;
    }
  });
};

// Changes by Arun
const saveWalletPassword = (recData) => {
  return axios.post(`${URL}/saveWalletPassword`, recData).then((response) => {
    const res = response.data;
    if (res.error) {
      ToastError(res.message);
    } else {
      // ToastSuccess(res.message);
      return res;
    }
  });
};

// Changes by Arun
const updateWalletPasswordByUserId = (recData) => {
  return axios
    .patch(`${URL}/updateWalletPasswordByUserId`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        return res;
      }
    });
};

const UpdateUser = (_id, recData) => {
  return axios
    .put(`${URL}/user/${_id}`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const updateBankDetailsByUserId = (_id, recData) => {
  return axios
    .put(`${URL}/updateBankDetailsByUserId/${_id}`, recData)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        ToastSuccess(res.message);
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const downloadFileByKey = (key) => {
  return axios
    .get(`${URL}/downloadFileByKey`, {
      headers: {
        key: key,
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const downloadFileBase64ByKey = (key) => {
  return axios
    .get(`${URL}/downloadFileBase64ByKey`, {
      headers: {
        key: key,
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const GetUserFindbyId = (_id) => {
  return axios
    .get(`${URL}/userById/${_id}`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

const getAllBankDetails = () => {
  return axios
    .get(`${URL}/getAllBankDetails/`)
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

//common getFileFromAWSS3BucketByKey

const GetFileFromAWSS3BucketByKey = (data) => {
  return axios
    .get(`${URL}/getFileFromAWSS3BucketByKey`, { headers: { key: data } })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        console.log(res.error);
      } else {
        return res;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

// written by gokul
const verifyMobileNumber = (data) => {
  return axios.get(`${URL}/verifyMobileNumber/${data}`).then((response) => {
    const res = response.data;
    if (res.error) {
      console.log(res.error);
    } else {
      return res;
    }
  });
};

const verifyEmailAddress = (data) => {
  return axios.get(`${URL}/verifyEmailAddress/${data}`).then((response) => {
    const res = response.data;
    if (res.error) {
      console.log(res.error);
    } else {
      return res;
    }
  });
};

// Changes by Arun
const base64toBlob = (base64Data, contentType) => {
  contentType = contentType || "";
  var sliceSize = 1024;
  var byteCharacters = atob(base64Data);
  var bytesLength = byteCharacters.length;
  var slicesCount = Math.ceil(bytesLength / sliceSize);
  var byteArrays = new Array(slicesCount);

  for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    var begin = sliceIndex * sliceSize;
    var end = Math.min(begin + sliceSize, bytesLength);

    var bytes = new Array(end - begin);
    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
};

const ChangeCredentials = (recData) => {
  return axios.post(`${URL}/changeCredentials`, recData).then((response) => {
    const res = response.data;
    if (res.error) {
      ToastError(res.message);
    } else {
      ToastSuccess(res.message);
      return res;
    }
  });
};

// The collection stores `provider` lowercased ("reliance"), but the company
// dropdown's <option value> is the display spelling ("Reliance"). A <select>
// only shows a selection when the two match EXACTLY, so an edit form opened
// straight from the stored value showed an empty company box. Map it back to
// the canonical spelling here — PROVIDER_COMPANIES is what fills the dropdown,
// so the two can never drift apart.
const toCanonicalCompany = (provider) => {
  const stored = String(provider || "").trim();
  return (
    PROVIDER_COMPANIES.find((c) => c.toLowerCase() === stored.toLowerCase()) || stored
  );
};

// Portal logins for a record, straight from the ProviderCredential collection —
// they are no longer carried on the user document, so the forms prefill from
// here. Returns [] rather than throwing so a failed read leaves the form usable.
const GetProviderCredentials = (userId) => {
  return axios
    .get(`${URL}/providerCredentials`, { params: { userId } })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
        return [];
      }
      return (res.data || []).map((cred) => ({
        ...cred,
        companyName: toCanonicalCompany(cred.companyName),
      }));
    })
    .catch((error) => {
      console.error("Failed to load provider credentials:", error);
      return [];
    });
};

// The saved default nominee for National — used by the automation only when a
// policy leaves its own nominee blank (National's portal now requires one on
// every quote, even without PA cover). Lives on the user/client record itself,
// not on ProviderCredential — see RayalBrokers-backend/Model/user.js. Always
// resolves to an object (never rejects) so the modal can bind straight to it.
const GetNationalNominee = (userId) => {
  return axios
    .get(`${URL}/nationalNominee`, { params: { userId } })
    .then((response) => {
      const res = response.data;
      if (res.error) {
        ToastError(res.message);
        return { name: "", relation: "", age: "" };
      }
      return res.data || { name: "", relation: "", age: "" };
    })
    .catch((error) => {
      console.error("Failed to load National nominee:", error);
      return { name: "", relation: "", age: "" };
    });
};

export {
  PostUser,
  GetUser,
  GetLogin,
  UpdateUser,
  GetUserFindbyId,
  getAllBankDetails,
  GetFileFromAWSS3BucketByKey,
  verifyMobileNumber,
  verifyEmailAddress,
  saveWalletPassword,
  updateWalletPasswordByUserId,
  updateBankDetailsByUserId,
  downloadFileByKey,
  downloadFileBase64ByKey,
  base64toBlob,
  ChangeCredentials,
  GetProviderCredentials,
  GetNationalNominee,
};
